import faq from './FAQ.txt';
import homeCarousel from './HomeCarousel.txt';
import homeDevices from './HomeDevices.txt';
import homeFAQ from './HomeFAQ.txt';
import homeFeatures from './HomeFeatures.txt';
import homePackages from './HomePackages.txt';
import homeTeasers from './HomeTeasers.txt';
import politikaZaPoveritelnost from './PolitikaZaPoveritelnost.txt';
import pravilaZaPolzvane from './PravilaZaPolzvane.txt';
import tvChannels from './TVChannels.txt';
import tvPaketi from './TVPaketi.txt';
import vr from './VR.txt';
import zaNas from './ZaNas.txt';

const cms = [];

cms.FAQ = faq;
cms.HomeCarousel = homeCarousel;
cms.HomeDevices = homeDevices;
cms.HomeFAQ = homeFAQ;
cms.HomeFeatures = homeFeatures;
cms.HomePackages = homePackages;
cms.HomeTeasers = homeTeasers;
cms.PolitikaZaPoveritelnost = politikaZaPoveritelnost;
cms.PravilaZaPolzvane = pravilaZaPolzvane;
cms.TVChannels = tvChannels;
cms.TVPaketi = tvPaketi;
cms.VR = vr;
cms.ZaNas = zaNas;

export default cms;
